// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--j4VkW";
export var content = "hero-module--content--LEOVe";
export var content2 = "hero-module--content2--3AdWC";
export var logo = "hero-module--logo--1G7pw";
export var buttonWrapper = "hero-module--button-wrapper--hul5n";
export var buttonEl = "hero-module--button-el--WbnFp";
export var overlay = "hero-module--overlay--3a4V8";